/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_New_DomainsInputs */

const en_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back to new domains`)
};

const es_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Volver a dominios nuevos`)
};

const fr_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Retour aux nouveaux domaines`)
};

const de_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Zurück zu neuen Domains`)
};

const ja_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 新しいドメインの設定に戻る`)
};

const zh_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 返回新域名设置`)
};

const ar_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← العودة إلى النطاقات الجديدة`)
};

const id_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Kembali ke domain baru`)
};

const it_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Torna ai nuovi domini`)
};

const ru_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Вернуться к новым доменам`)
};

const pt_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar para novos domínios`)
};

const ko_back_to_new_domains = /** @type {(inputs: Back_To_New_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 새 도메인으로 돌아가기`)
};

/**
* | output |
* | --- |
* | "← Back to new domains" |
*
* @param {Back_To_New_DomainsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const back_to_new_domains = /** @type {((inputs?: Back_To_New_DomainsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_New_DomainsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_to_new_domains(inputs)
	if (locale === "es") return es_back_to_new_domains(inputs)
	if (locale === "fr") return fr_back_to_new_domains(inputs)
	if (locale === "de") return de_back_to_new_domains(inputs)
	if (locale === "ja") return ja_back_to_new_domains(inputs)
	if (locale === "zh") return zh_back_to_new_domains(inputs)
	if (locale === "ar") return ar_back_to_new_domains(inputs)
	if (locale === "id") return id_back_to_new_domains(inputs)
	if (locale === "it") return it_back_to_new_domains(inputs)
	if (locale === "ru") return ru_back_to_new_domains(inputs)
	if (locale === "pt") return pt_back_to_new_domains(inputs)
	return ko_back_to_new_domains(inputs)
});